import React from 'react';
import { Paper, PaperProps, styled } from '@mui/material';

const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: theme.spacing(2), // 16px
  padding: theme.spacing(3),
  background: theme.palette.mode === 'dark' 
    ? 'linear-gradient(145deg, #111827 0%, #0F172A 100%)' 
    : 'linear-gradient(145deg, #FFFFFF 0%, #F8FAFC 100%)',
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[1],
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: theme.shadows[3],
    borderColor: theme.palette.mode === 'dark' ? '#334155' : '#CBD5E1',
  },
}));

interface PremiumCardProps extends PaperProps {
  children: React.ReactNode;
}

export const PremiumCard: React.FC<PremiumCardProps> = ({ children, ...props }) => {
  return (
    <StyledPaper elevation={0} {...props}>
      {children}
    </StyledPaper>
  );
};

export default PremiumCard;
